/**
 * Whether a tool binding actually needs a credential set. MCP adapters
 * always do; in-process/native adapters only when the capability
 * explicitly declares requires_credentials. Used to suppress false
 * "no credentials" warnings on built-in tools.
 */
export function adapterNeedsCredentials(
  adapter?: { kind: string },
  capability?: { requires_credentials?: boolean },
): boolean {
  if (capability?.requires_credentials) return true
  return adapter?.kind === 'mcp'
}
